class Partners extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-partner-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            slidesPerView: 2,
            spaceBetween: 30,
            breakpoints: {
                500: {
                    slidesPerView: 3,
                },
                1100: {
                    slidesPerView: 5,
                }
            },
            navigation: {
                nextEl: '[data-partner-next]',
                prevEl: '[data-partner-prev]',
            },
            pagination: {
                el: '[data-partner-pagination]',
                clickable: true
            },
        });
    }
}
